import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0014e86a")

_pushScopeId("data-v-0014e86a")
const _hoisted_1 = {
  key: 0,
  class: "ui__ensure_main"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "ui__line_main" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "ui__ensure_title" }, [
  /*#__PURE__*/_createTextVNode("保障服务说明 "),
  /*#__PURE__*/_createVNode("i")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "ui__ensure_main"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "ui__line_main" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "ui__ensure_title" }, [
  /*#__PURE__*/_createTextVNode("保障服务说明 "),
  /*#__PURE__*/_createVNode("i")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    (_ctx.state.channelType === 'lingshou')
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          (_ctx.state.point === 'N' && _ctx.state.serviceGuarantee !== '')
            ? (_openBlock(), _createBlock("div", _hoisted_1, [
                _hoisted_2,
                _createVNode("div", {
                  class: "ui__ensure_body",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toView && _ctx.toView(...args)))
                }, [
                  _hoisted_3
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          (_ctx.state.point === 'N' && _ctx.state.reportLevel !== 16)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _hoisted_5,
                _createVNode("div", {
                  class: "ui__ensure_body",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toView && _ctx.toView(...args)))
                }, [
                  _hoisted_6
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
})